@if (loadingService.loadingStatus | async) {
    <div class="global-loader">
        <img src="./assets/images/loading.svg" />
    </div>
}
<router-outlet></router-outlet>
